import simplelightbox from 'simplelightbox';

export default function product() {
    $('.product-parent .photos a').simpleLightbox({
        history: false
    });

    $('.product-parent .products .specsheet-link').attr('target', '_blank');

    var product_title;

    $('.product-parent .products .enquiry-link').simpleLightbox({
        fileExt: false,
        preloading: false,
        nav: false,
        showCounter: false,
        enableKeyboard: false,
        additionalHtml: function() {
            return $('.product-parent .product-enquiry-success').html()
                .replace('{{ product }}', product_title);
        }
    }).on('show.simplelightbox', function() {
        product_title = $(this).data('product-title');
    });
}
